(function () {
    'use strict';
    /**
     * Initialise the location finder
     * 
     * @memberof module:eventCarouselSlick
     */
    function initEventFeed () {
        const eventsFeed = document.querySelector('.qld__event-feed');

        if(eventsFeed) {
            // let $slick = $(`[data-action="slick-slider"]`);

            $('.qld__event-feed__card--list').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight:true,
                adaptiveWidth: true,
                centerMode: true,
                dots: false,
                prevArrow:'<button type="button" class="controls-prev"><i class="fa fa-chevron-left"></i></button>',
                nextArrow:'<button type="button" class="controls-next"><i class="fa fa-chevron-right"></i></button>',
                    responsive: [
                       
                        {
                            breakpoint: 390,
                            settings: {
                                slidesToShow: 1,
                                // slidesToScroll: 1,
                                centerMode: true,
                                centerPadding: '0px',
                            }
                        }
                    ]
            });
            }
        }

    document.addEventListener('DOMContentLoaded', initEventFeed);

    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".qld__tag-list .qld__tag").forEach(tag => {
            // Only format if tag contains a single text node (no nested elements)
            if (tag.childNodes.length === 1 && tag.childNodes[0].nodeType === Node.TEXT_NODE) {
                let formattedText = tag.textContent
                    .replace(/_/g, " ")
                    .toLowerCase()
                    .replace(/^(\w)/, char => char.toUpperCase());
    
                tag.textContent = formattedText;
            }
        });
    });
    

    // let slickInstance = $('.qld__event-feed__card--list').slick('getSlick');
    // console.log(slickInstance);
})();

